import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { checkAndGetNewAccessToken } from './checkAndGetNewAccessToken';

export interface IAddAioCallOutcomeResponse {
  success: boolean;
  message?: string;
  data?: Record<string, unknown>;
}

export interface ILiveLead {
  intentId: number;
  globalTraceId: string;
  updateDate?: string | null;
  status:
    | 'ROUTED'
    | 'CONTACTED'
    | 'ACCEPTED'
    | 'AWAITING_CONTACT'
    | 'CONTACT_DECLINED'
    | 'CONNECTED'
    | 'OUTCOME_SENT'
    | 'AGENT_REJECTED'
    | 'OUTCOME_COLLECTED'
    | 'EXPIRED'
    | 'FAILED';
  statusDetail?: string | null;
  contactName: string | null;
  contactPhoneNumber: string | null;
  agentPhoneNumber: string | null;
  routingRule: string | null;
  decisionDenyReason: string | null;
}

export interface IGetLiveLeadsResponse {
  success: boolean;
  leads: ILiveLead[];
  totalCount: number;
  startDate?: string;
  endDate?: string;
}

export interface IQueryProps {
  userSettings:
    | {
        apikey: string;
        businessId: number;
        userid: number | string;
        timezone?: string;
      }
    | undefined;
  refetch?: string;
  extension?: string;
}

export const aioQuery = createApi({
  reducerPath: 'aioQuery',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.VITE_APP_AIO_DOMAIN, //'https://pduong-aio.dev-1.k8s.kixie.com',
    prepareHeaders: async (headers) => {
      // check if accessToken not expired else retrieve new access token and make request
      if (!headers.has('authorization')) {
        const {
          accessToken: newAccessToken,
        } = await checkAndGetNewAccessToken();
        if (newAccessToken) {
          headers.set('authorization', newAccessToken);
        }
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    addAioCallOutcome: builder.mutation<
      IAddAioCallOutcomeResponse,
      IQueryProps & {
        payload: Record<string, unknown>;
      }
    >({
      query: (props) => ({
        url: 'aio/aioprocessoutcome',
        method: 'POST',
        body: props.payload,
        headers: {
          'x-api-key': props.userSettings?.apikey,
          'content-type': 'application/json;charset=utf-8',
        },
      }),
    }),
    getLiveLeads: builder.query<
      IGetLiveLeadsResponse,
      {
        start?: string;
        end?: string;
        businessId?: number;
      }
    >({
      query: (params) => ({
        url: 'aio/lead-flow',
        method: 'GET',
        params: {
          ...(params.start && { start: params.start }),
          ...(params.end && { end: params.end }),
          ...(params.businessId && { businessId: params.businessId }),
        },
      }),
    }),
  }),
});

export const { useAddAioCallOutcomeMutation, useGetLiveLeadsQuery } = aioQuery;
